import React, { useState, useEffect } from 'react';
import Spiner from '../Components/Admin/Spiner/Spiner';
import { Outlet } from 'react-router-dom';
import Auth from '../Components/Admin/Auth/Auth';
import baseURL from '../Components/url';

export default function MainLayout() {
    const [usuario, setUsuario] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${baseURL}/userLogued.php`);
                if (!response.ok) {
                    throw new Error('La respuesta de red no fue correcta');
                }
                const data = await response.json();
                setUsuario(data);
                setLoading(false);
            } catch (error) {
                console.error('Error al obtener datos del usuario:', error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <div>
            <div>
                {loading ? (
                    <Spiner />
                ) : usuario.idUsuario && usuario.rol === 'admin' && usuario.storeStatusIsSuspended ? (
                    <section className='storeAccessPage'>
                        <div className='storeAccessCard isSuspended'>
                            <span className='storeAccessEyebrow'>Tienda pausada</span>
                            <h2>Dashboard temporalmente no disponible</h2>
                            <p>{usuario.storeStatusMessage || 'Esta tienda esta pausada temporalmente. Contacta a soporte para reanudarla.'}</p>
                        </div>
                    </section>
                ) : usuario.idUsuario && usuario.rol === 'admin' ? (
                    <>
                        {usuario.storeStatusHasWarning && (
                            <div className='storeAccessBanner'>
                                <strong>{usuario.storeStatusLabel}:</strong> {usuario.storeStatusMessage}
                            </div>
                        )}
                        <Outlet />
                    </>
                ) : (
                    <Auth />
                )}
            </div>
        </div>
    );
}
